module.exports = __webpack_public_path__ + "img/fun8.a87e5afa.png";